/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface ContactInterface {
  internal: boolean;
  salutation?: string;
  firstname: string;
  lastname: string;
  name: string;
  email?: string;
  phone?: string;
  fax?: string;
  dateofbirth?: string;
  nationality?: string;
  status: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Contact implements ContactInterface {
  internal: boolean;
  salutation: string;
  firstname: string;
  lastname: string;
  name: string;
  email: string;
  phone: string;
  fax: string;
  dateofbirth: string;
  nationality: string;
  status: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: ContactInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Contact`.
   */
  public static getModelName() {
    return "Contact";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Contact for dynamic purposes.
  **/
  public static factory(data: ContactInterface): Contact{
    return new Contact(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Contact',
      plural: 'contacts',
      properties: {
        internal: {
          name: 'internal',
          type: 'boolean',
          default: true
        },
        salutation: {
          name: 'salutation',
          type: 'string'
        },
        firstname: {
          name: 'firstname',
          type: 'string'
        },
        lastname: {
          name: 'lastname',
          type: 'string'
        },
        name: {
          name: 'name',
          type: 'string'
        },
        email: {
          name: 'email',
          type: 'string'
        },
        phone: {
          name: 'phone',
          type: 'string'
        },
        fax: {
          name: 'fax',
          type: 'string'
        },
        dateofbirth: {
          name: 'dateofbirth',
          type: 'string'
        },
        nationality: {
          name: 'nationality',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Contact.ts